import type { SegmentTranscript } from '@/types/interview'
import { t } from '@/i18n/translations'

interface Props { language: string; transcripts: SegmentTranscript[]; onBack?: () => void }

export function InterviewSummary({ language, transcripts, onBack }: Props) {
  const backLabel = language === 'de' ? '← Zurück' : '← Back'
  return (
    <div className="summary" style={{ display: 'block' }}>
      {onBack && (
        <button className="back-btn back-btn-inline" onClick={onBack}>
          {backLabel}
        </button>
      )}
      <h3>{t(language, 'interviewSummary')}</h3>
      <p>{transcripts.length} {t(language, 'sectionsCompleted')}</p>
      <div id="summary-content">
        {transcripts.map((tr) => (
          <div key={tr.question_number} className="transcript-item" style={{ marginBottom: 16, padding: 12, background: 'rgba(255,255,255,0.05)', borderRadius: 8 }}>
            <p style={{ color: '#00ADEF', textTransform: 'capitalize' }}><b>{tr.question_number ?? 'Unknown Question'}</b> ({tr.speaker})</p>
            <p style={{ margin: '8px 0 0', color: '#4c4c4c' }}><b>{t(language, 'yourResponse')}:</b> {tr.content}</p>
          </div>
        ))}
      </div>
    </div>
  )
}
